<template>
  <div class="isolate">
    <ComingSoonPage v-if="isComingSoonPage" />
    <template v-else>
      <ProductJapanModular v-if="isJapanProductPage" />
      <ProductUsModular v-else-if="isUsProductPage" />
      <GlobalProductDetailPage v-else />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { useMasterPP } from '~/scopes/product-core/composables/useMasterPP/useMasterPP'

const GlobalProductDetailPage = defineAsyncComponent(
  () =>
    import('~/scopes/product-core/pages/ProductDetailPage/global/GlobalProductDetailPage.vue'),
)
const ProductJapanModular = defineAsyncComponent(
  () =>
    import('~/scopes/product-core/pages/ProductDetailPage/jp/JPProductDetailPage.vue'),
)
const ProductUsModular = defineAsyncComponent(
  () =>
    import('~/scopes/product-core/pages/ProductDetailPage/us/USProductDetailPage.vue'),
)
const ComingSoonPage = defineAsyncComponent(
  () => import('~/scopes/product-core/pages/ComingSoonPage/ComingSoonPage.vue'),
)

const { market } = useMarketplace()
const { masterPDPComingSoon } = useMasterPP()

const isJapanProductPage = computed(
  () => market.countryCode === MarketCountryCode.JP,
)

const isUsProductPage = computed(
  () => market.countryCode === MarketCountryCode.US,
)

const isComingSoonPage = computed(() => {
  return masterPDPComingSoon.value
})
</script>
